import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import mobileFavicon from '@/assets/icons/Isotipo_Original.png';

const ensureFavicon = () => {
  let iconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!iconLink) {
    iconLink = document.createElement('link');
    iconLink.rel = 'icon';
    document.head.appendChild(iconLink);
  }
  iconLink.type = 'image/png';
  iconLink.href = mobileFavicon;
};

ensureFavicon();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
